export default `vec3 q = vec3(-.1,.65,-.6);
  float j,i,e,v,u;
  for(j=e=v=7.;j++<21.;e=min(e,max(length(p.xz=abs(p.xz*rotate2D(j+sin(1./u)/v))-.53)-.02/u,p.y=1.8-p.y)/v))
    v/=u=dot(p,p),p/=u+.01;
  return e;
}`